import React, { FC, useMemo } from 'react'

interface Props {
  size?: number
}

export const InstagramIconEnhanced: FC<Props> = ({ size = 32 }) => {
  // 生成唯一ID避免多个实例间冲突
  const uniqueId = useMemo(
    () => `instagram-gradient-${Math.random().toString(36).substr(2, 9)}`,
    []
  )

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="16" fill={`url(#${uniqueId})`} />
      <path
        d="M19.7141 7.99146C22.0859 7.99157 24.009 9.91397 24.009 12.2857V19.7141C24.0089 22.0858 22.0858 24.0089 19.7141 24.009H12.2857C9.91396 24.009 7.99155 22.0859 7.99146 19.7141V12.2857C7.99151 9.91393 9.91393 7.99151 12.2857 7.99146H19.7141ZM12.2857 9.15161C10.555 9.15166 9.15166 10.555 9.15161 12.2857V19.7141C9.15171 21.4448 10.555 22.8482 12.2857 22.8482H19.7141C21.4448 22.8481 22.8481 21.4448 22.8482 19.7141V12.2857C22.8482 10.555 21.4448 9.15172 19.7141 9.15161H12.2857ZM15.9999 12.1698C18.1154 12.1698 19.83 13.8845 19.83 15.9999C19.83 18.1154 18.1154 19.83 15.9999 19.83C13.8845 19.83 12.1698 18.1154 12.1698 15.9999C12.1698 13.8845 13.8845 12.1698 15.9999 12.1698ZM15.9999 13.33C14.5255 13.33 13.33 14.5255 13.33 15.9999C13.33 17.4743 14.5255 18.6698 15.9999 18.6698C17.4743 18.6698 18.6698 17.4743 18.6698 15.9999C18.6698 14.5255 17.4743 13.33 15.9999 13.33ZM20.1783 10.8925C20.6911 10.8925 21.1073 11.3087 21.1073 11.8215C21.1072 12.3343 20.6911 12.7499 20.1783 12.7499C19.6656 12.7498 19.25 12.3342 19.2499 11.8215C19.2499 11.3088 19.6656 10.8926 20.1783 10.8925Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={uniqueId}
          x1="1.71429"
          y1="2"
          x2="32"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.147306" stopColor="#8646EE" />
          <stop offset="0.514423" stopColor="#FF3190" />
          <stop offset="0.898924" stopColor="#FFE658" />
        </linearGradient>
      </defs>
    </svg>
  )
}
